import React from "react";
import ReactECharts from "echarts-for-react";

const LineChart = ({ data,range,display  }) => {

    const options = {
        grid: {
            left: "10%",
            right: "10%",
            top: "20%",
            bottom: "15%",
        },
        tooltip: {
            trigger: "axis", // Display tooltip for the whole axis line
            axisPointer: {
                type: "line", // Highlight the line corresponding to the axis value
            },
            formatter: (params) => {
                const item = params[0]; // Access the data point
                if (item.value === null || item.value === undefined) {
                    return ""; // Return an empty string to hide tooltip
                }
                if (range === "Quarter"||range==="LastQuarter") {
                    return `Week ${item.name}: ${item.value}`;
                }
                return `${item.name}: ${item.value}`;
            },
        },
        xAxis: {
            type: "category",
            data: data.xData,
            boundaryGap: false,
            axisTick: {
                alignWithLabel: true,
                inside: true, // Position ticks inside, making them appear higher
            },
            axisLabel: {
                showMinLabel: true, // Always show the first label
                showMaxLabel: true, // Always show the last label
                interval: 'auto', // Show all labels; adjust as needed based on space
            },
        },
        yAxis: {
            type: "value",
        },
        // dataZoom: [
        //     {
        //       type: "slider",
        //       xAxisIndex: 0,
        //       start: 0,
        //       end: 50, // Show the first 100% initially
        //       bottom: "10px", // Move the slider up to avoid overlapping
        //       handleSize: "100%", // Make the handle larger for better UX
        //       handleStyle: {
        //         color: "#85D7FF", // Light blue handle color
        //         borderWidth: 1,
        //         borderColor: "#5AB1F6", // Slightly darker blue border
        //       },
        //       fillerColor: "rgba(133, 215, 255, 0.2)", // Transparent light blue background
        //       borderColor: "transparent", // Remove the border for a cleaner look
        //       textStyle: {
        //         color: "transparent", // Hide text
        //       },
        //     },
        //   ],
        series: [
            {
                data: data.yData,
                type: "line",
                smooth: false,
                connectNulls: false,
                lineStyle: {
                    color: "#85D7FF", // Orange line color
                },
                symbol: "circle", // Add circles at data points
                symbolSize: 3,
            },
        ],
        title: {
            show: range === "Quarter"|| range==="LastQuarter", // ✅ Show title only if range is "Quarter"
            text: display, // ✅ Dynamically show selectedRangeDisplay
            left: "center",
            bottom: 0,
            textStyle: {
              fontSize: 14,
              fontWeight: "normal",
              color: "#666",
            },
            backgroundColor: "#fff",
            borderColor: "#ddd",
            borderWidth: 0.5,
            borderRadius: 2,
            padding: [10, 30, 10, 30],
          },
    };

    return (
        <div className="chart-container">
            <ReactECharts
                option={options}
                style={{ height: "450px", width: "100%", marginTop: "-80px" }}
            />
        </div>
    );
};

export default LineChart;
